import {Image} from '@/_application/core/components/ui/image';
import Link from '@/_application/core/components/ui/link';
import {getBrandUrl} from '@/_application/core/utils/common';
import {CategoryTree} from '__generated__/__types__';
import cn from 'classnames';
import {motion} from 'framer-motion';
import SidebarCategoryLevel2Item from './kidsplaza-spring.desktop.sidebar-category-level-2-item';
import {useHighlightBrands} from '@/framework/highlight-brands';

interface IProps {
    currentCategory: CategoryTree;
    isHeader: boolean;
    onHover: (categoriesLevel2: CategoryTree) => void;
    onLeave: () => void;
}

function SidebarCategoryLevel2List({currentCategory, isHeader, onHover, onLeave}: Readonly<IProps>) {
    const handleHover = () => {
        onHover(currentCategory);
    };
    const {highlightBrands} = useHighlightBrands();
    const brands = highlightBrands.filter(brand => brand?.img && brand.url);
    const amountChildren = currentCategory.children?.length ?? 0;

    return (
        <motion.div
            initial={{scale: 0.9, opacity: 0}}
            animate={{scale: 1, opacity: 1}}
            transition={{ease: 'easeInOut', duration: 0.1}}
            className={cn(
                'absolute left-full top-0 z-20 flex w-[715px] rounded-br-[20px] rounded-tr-[20px] border-l border-solid border-black/20 bg-white text-KPZ_text_1st',
                {
                    'h-[390px] pr-5': isHeader,
                    'h-[428px]': !isHeader,
                },
            )}
            onMouseEnter={handleHover}
            onMouseLeave={onLeave}>
            <ul
                className={cn(
                    'flex h-full w-2/3 flex-col flex-wrap gap-[11px] border-r border-solid border-KPZ_divider pb-5 pr-10 text-[12px]',
                    {
                        'pt-[38px]': isHeader,
                        'pt-[68px]': !isHeader,
                    },
                )}>
                {currentCategory?.children?.map(categoryLevel2 => (
                    <SidebarCategoryLevel2Item
                        key={categoryLevel2?.id}
                        categoryLevel2={categoryLevel2 as CategoryTree}
                        isHeader={isHeader}
                        parentLength={amountChildren}
                    />
                ))}
            </ul>
            <div className="w-1/3 px-5 pb-7 pt-[68px]">
                <div
                    className={cn('sidebar-brand-scrollbar flex flex-wrap justify-center gap-[10px] overflow-auto', {
                        'h-full': brands.length > 16,
                    })}>
                    {brands.slice(0, 30).map(brand => {
                        if (!brand?.img || !brand.url) return <></>;
                        const brandUrl = getBrandUrl(brand.url);

                        return (
                            <Link
                                key={brand.url}
                                href={brandUrl}
                                className="flex h-[32px] w-[72px] select-none items-center justify-center overflow-hidden rounded-[10px] border border-solid border-KPZ_turquoise bg-white">
                                <div className="flex h-[25px] w-[50px] items-center justify-center p-2.5">
                                    <Image
                                        src={brand.img}
                                        alt={brand.label ?? 'brand-image'}
                                        width={100}
                                        height={100}
                                    />
                                </div>
                            </Link>
                        );
                    })}
                </div>
            </div>
        </motion.div>
    );
}

export default SidebarCategoryLevel2List;
